import { ANALYTICS_PERIOD_OPTIONS, type AnalyticsPeriod } from './service/types';

export interface AnalyticsRouteSearch {
  period: AnalyticsPeriod;
}

function parseAnalyticsPeriod(value: unknown): AnalyticsPeriod {
  if (value === '7d' || value === '30d') {
    return value;
  }

  return '7d';
}

export function validateAnalyticsSearch(search: Record<string, unknown>): AnalyticsRouteSearch {
  return {
    period: parseAnalyticsPeriod(search.period),
  };
}

export function analyticsLoaderDeps(search: AnalyticsRouteSearch) {
  return {
    period: ANALYTICS_PERIOD_OPTIONS.includes(search.period) ? search.period : '7d',
  };
}
